import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn } from "@similarweb/ui-components";

export const StyledSignalsEmptyViewWrapper = styled(FlexColumn)`
    align-items: center;
    width: 100%;
`;

export const StyledSignalsEmptyImageBlock = styled.div`
    display: flex;
    width: 160px;
    height: 84px;
    margin-bottom: 16px;
`;

export const StyledSignalsEmptyTitle = styled.div`
    display: flex;
    ${setFontVariant("subtitle1", colorsPalettes.carbon[500])}
`;

export const StyledSignalsEmptySubTitle = styled.div`
    display: flex;
    max-width: 360px;
    text-align: center;
    ${setFontVariant("caption", colorsPalettes.carbon[300])};
    line-height: 20px;
    margin-bottom: 16px;
`;

export const StyledEmptyStateIcon = styled(SWReactIcons)`
    height: 96px;
    width: 160px;
    margin-bottom: 16px;

    > svg {
        height: inherit;
        width: inherit;
    }
`;
